import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'elements';
import SandwichIcon from 'elements/icon/assets/menu.svg';
import CloseIcon from 'elements/icon/assets/close.svg';
import { SandwichWrapper } from './Navigation.styled.js';

const Sandwich = ({ isMenuOpen, onClick }) => {
  return (
    <SandwichWrapper>
      <Icon onClick={onClick} modifiers={['small', 'darkGrayColor']}>
        {isMenuOpen ? <CloseIcon /> : <SandwichIcon />}
      </Icon>
    </SandwichWrapper>
  );
};

Sandwich.defaultProps = {
  isMenuOpen: false,
  onClick: null,
};
Sandwich.propTypes = { isMenuOpen: PropTypes.bool, onClick: PropTypes.func };

export default Sandwich;
